module.exports = __webpack_public_path__ + "03_short_gold.37840763.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_short_gold.png
// module id = lkff
// module chunks = 0